module.exports = __webpack_public_path__ + "img/PL08129.0e7ca0ef.png";